import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { ADD_BUTTON_CLICKED, NEW_TEMPLATE_ADDED, NEW_TRANSLATION_ADDED, NEW_TEMPLATE_STARTED, NEW_TEMPLATE_SELECTED, NEW_TEMPLATE_SAVED, NEW_TEMPLATE_SENT, TEMPLATE_DUPLICATED, TEMPLATE_DELETED, CACHE_RESTARTED, } from './MessageTemplateSegmentEvents';
export class MessageTemplateSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackAddButtonClicked(payload, success) {
        this.trackEvent(ADD_BUTTON_CLICKED, payload, success);
    }
    trackNewTemplateAdded(payload, success) {
        this.trackEvent(NEW_TEMPLATE_ADDED, payload, success);
    }
    trackNewTranslationAdded(payload, success) {
        this.trackEvent(NEW_TRANSLATION_ADDED, payload, success);
    }
    trackTemplateDuplicated(payload, success) {
        this.trackEvent(TEMPLATE_DUPLICATED, payload, success);
    }
    trackTemplateDeleted(payload, success) {
        this.trackEvent(TEMPLATE_DELETED, payload, success);
    }
    trackRefreshCache(payload, success) {
        this.trackEvent(CACHE_RESTARTED, payload, success);
    }
    trackNewTemplateStarted(payload, success) {
        this.trackEvent(NEW_TEMPLATE_STARTED, payload, success);
    }
    trackNewTemplateSelected(payload, success) {
        this.trackEvent(NEW_TEMPLATE_SELECTED, payload, success);
    }
    trackNewTemplateSaved(payload, success) {
        this.trackEvent(NEW_TEMPLATE_SAVED, payload, success);
    }
    trackNewTemplateSent(payload, success) {
        this.trackEvent(NEW_TEMPLATE_SENT, payload, success);
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, { ...payload, Status: this.eventStatus(success) });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
MessageTemplateSegmentService.$inject = ['SegmentService'];
